(ns measure.resource.report-schedule
  (:require [camel-snake-kebab.core :as csk]
            [camel-snake-kebab.extras :as cske]
            [common.url-template :as url-tpl]
            [re-frame.core :as rf]))

(rf/reg-event-fx :resource.report-schedule/post
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :url-context)]
  (fn [{:keys [url-context] :as cofx} [_ params]]
    {:fx [[:http
           {:method :post
            :uri (url-tpl/render :measure-api/report-schedule-create url-context)
            :params (->> (merge params (select-keys url-context [:advertiser-id]))
                         (cske/transform-keys csk/->snake_case))
            :headers {"Authorization" (:resource.user/token cofx)}
            :on-success [:resource.report-schedule/post-success]
            :on-failure [:resource.report-schedule/post-failure]}]]}))

(rf/reg-event-db :resource.report-schedule/post-success
  identity)

(rf/reg-event-db :resource.report-schedule/post-failure
  identity)

(rf/reg-event-fx :resource.report-schedule/patch
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :url-context)]
  (fn [{:keys [url-context] :as cofx} [_ params]]
    {:fx [[:http
           {:method :patch
            :uri (url-tpl/render :measure-api/report-schedule (assoc url-context :report-config-id (:id params)))
            :params (->> (merge params (select-keys url-context [:advertiser-id]))
                         (cske/transform-keys csk/->snake_case))
            :headers {"Authorization" (:resource.user/token cofx)}
            :on-success [:resource.report-schedule/patch-success]
            :on-failure [:resource.report-schedule/patch-failure]}]]}))

(rf/reg-event-db :resource.report-schedule/patch-success
  identity)

(rf/reg-event-db :resource.report-schedule/patch-failure
  identity)
